// import React, { createContext, useContext, useState, useEffect } from "react";

// const AuthContext = createContext(null);

// export const useAuth = () => {
//   const context = useContext(AuthContext);
//   if (!context) {
//     throw new Error("useAuth must be used within AuthenticationStateManager");
//   }
//   return context;
// };

// const AuthenticationStateManager = ({ children }) => {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [user, setUser] = useState(null);
//   const [authLoading, setAuthLoading] = useState(true);

//   // ✅ Runs only once
//   useEffect(() => {
//     const initializeAuth = () => {
//       try {
//         const token = localStorage.getItem("token");
//         const storedUser = localStorage.getItem("user");

//         if (token && storedUser) {
//           setUser(JSON.parse(storedUser));
//           setIsAuthenticated(true);
//         } else {
//           setUser(null);
//           setIsAuthenticated(false);
//         }
//       } catch (error) {
//         console.error("Auth initialization failed:", error);
//         setUser(null);
//         setIsAuthenticated(false);
//       } finally {
//         setAuthLoading(false);
//       }
//     };

//     initializeAuth();
//   }, []);

//   const login = (token, userData) => {
//     localStorage.setItem("token", token);
//     localStorage.setItem("user", JSON.stringify(userData));

//     setUser(userData);
//     setIsAuthenticated(true);
//   };

//   const logout = () => {
//     console.log("AuthenticationStateManager - Logging out...");
//     localStorage.removeItem("token");
//     localStorage.removeItem("user");

//     setUser(null);
//     setIsAuthenticated(false);
//     console.log("AuthenticationStateManager - Logout completed");
//   };

//   const updateUser = (updatedData) => {
//     const newUser = { ...user, ...updatedData };
//     setUser(newUser);
//     localStorage.setItem("user", JSON.stringify(newUser));
//   };

//   return (
//     <AuthContext.Provider
//       value={{
//         isAuthenticated,
//         user,
//         authLoading,
//         login,
//         logout,
//         updateUser,
//       }}
//     >
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export default AuthenticationStateManager;

import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthenticationStateManager");
  }
  return context;
};

const AuthenticationStateManager = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  // ✅ NEW STATE (Fix for your error)
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  /* ===============================
     INITIALIZE AUTH
  =============================== */

  useEffect(() => {
    const initializeAuth = () => {
      try {
        const token = localStorage.getItem("token");
        const storedUser = localStorage.getItem("user");

        if (token && storedUser) {
          setUser(JSON.parse(storedUser));
          setIsAuthenticated(true);
        } else {
          setUser(null);
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error("Auth initialization failed:", error);
        setUser(null);
        setIsAuthenticated(false);
      } finally {
        setAuthLoading(false);
      }
    };

    initializeAuth();
  }, []);

  /* ===============================
     LOGIN
  =============================== */

  const login = (token, userData) => {
    setIsLoggingIn(true);

    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(userData));

    setUser(userData);
    setIsAuthenticated(true);

    setIsLoggingIn(false);
  };

  /* ===============================
     LOGOUT
  =============================== */

  const logout = () => {
    console.log("AuthenticationStateManager - Logging out...");

    localStorage.removeItem("token");
    localStorage.removeItem("user");

    setUser(null);
    setIsAuthenticated(false);

    console.log("AuthenticationStateManager - Logout completed");
  };

  /* ===============================
     UPDATE USER
  =============================== */

  const updateUser = (updatedData) => {
    const newUser = { ...user, ...updatedData };
    setUser(newUser);
    localStorage.setItem("user", JSON.stringify(newUser));
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        user,
        authLoading,
        login,
        logout,
        updateUser,

        // ✅ Added so AuthenticationForm can use them
        isLoggingIn,
        setIsLoggingIn,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthenticationStateManager;